import { render, staticRenderFns } from "./LandingTarifs.vue?vue&type=template&id=492baa56&scoped=true"
import script from "./LandingTarifs.vue?vue&type=script&lang=js"
export * from "./LandingTarifs.vue?vue&type=script&lang=js"
import style0 from "./LandingTarifs.vue?vue&type=style&index=0&id=492baa56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492baa56",
  null
  
)

export default component.exports